import React from 'react';
import PropTypes from 'prop-types';

export default function TitleValue(props) {
  let { title, value, size, id, ...args } = props;
  return (
    <div
      className={`km__c--title-value-container km__c--title-value-is-${size}`}
      {...args}
    >
      {title ? (
        <div className='km__c--title-value-title' id={`${id}-title`}>
          {title}
        </div>
      ) : null}
      {value !== '' ? (
        <div className='km__c--title-value-value' id={`${id}-value`}>
          {value}
        </div>
      ) : null}
    </div>
  );
}
TitleValue.propTypes = {
  title: PropTypes.any,
  value: PropTypes.any,
  size: PropTypes.oneOf(['lg', 'md']),
};
TitleValue.defaultProps = {
  size: 'md',
};
